var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"map"},[_c('div',{ref:"map",attrs:{"id":"map"}}),(_vm.load_more !== null)?_c('div',{staticClass:"mt-4 d-flex align-center justify-content-start"},[_c('vb-button',{attrs:{"vb_options":{
        text: 'Mostra più risultati',
        variant: 'primary',
        size: 'md',
        disabled: _vm.loading,
      }},on:{"click":function($event){return _vm.load_more()}}}),(_vm.loading)?_c('loader',{staticClass:"ml-3 mt-2"}):_vm._e()],1):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }